import React from 'react';
import { Img } from 'react-image';

import { Modal } from '../../../../../../../components';

import { RedWarning } from '../../../../../../../assets/svg-image/common';

import {
  OkeyBtn,
} from './Styles';
import { lang } from '../../../../../../../lib/utils/utils';
import { Column, ColumnCenter } from '../Styles';
import { RegularCabSelected } from '../../../../../../../assets/base64Images/cab-size/Regular-cab-selected';
import { closeBlack } from '../../../../../../../assets/Base64Image';
import SquadBoldText from '../../../../../../../components/Text/SquadBoldText';
import PingFangSemiBoldText from '../../../../../../../components/Text/PingFangSemiBoldText';
import SquadRegularText from '../../../../../../../components/Text/SquadRegularText';
import PingFangRegularText from '../../../../../../../components/Text/PingFangRegularText';

const LargeCabNoFreeBoxModal: React.FC<Props> = ({
  onClose,
  onConfirm,
  onQuit,
}) => {
  return (
    <Modal
      style={{ width: 303, minWidth: 'unset', padding: 'unset', textAlign: 'center', paddingBottom: '26px', borderRadius: '22px' }}
    >
      {/* 图标 */}
      <div>
        <img src={RedWarning} style={{ width: '72px', height: '71px', marginTop: '-35px' }} />
      </div>

      {/* 关闭图标 */}
      <div
        onClick={() => onClose()}
        style={{ padding: '10px', width: '30px', height: '30px', marginLeft: 'auto', marginRight: '10px', marginTop: '-35px' }}
      >
        <img src={closeBlack} style={{ width: '14px', height: '14px', marginTop: 8, marginLeft: 18 }} />
      </div>

      {
        lang(
          <SquadBoldText fontSize={22} marginTop={10}>
            Sorry…
          </SquadBoldText>,
          <PingFangSemiBoldText fontSize={22} marginTop={10}>
            抱歉…
          </PingFangSemiBoldText>
        )
      }
      {
        lang(
          <SquadRegularText fontSize={16} lineHeight={21} opacity={0.7} textAlign={'center'} marginTop={5}>
            There are no more tall cubicles
            <br />
            available, but you still can use a
            <br />
            regular size cubicle!
          </SquadRegularText>,
          <PingFangRegularText fontSize={16} lineHeight={21} opacity={0.7} textAlign={'center'} marginTop={5}>
            现在暂时没有加大尺寸智能柜
            <br />
            可以使用，请问是否选择使用
            <br />
            普通尺寸的智能柜
          </PingFangRegularText>
        )
      }

      <ColumnCenter style={{ marginTop: 15 }}>
        <Column>
          <Img src={RegularCabSelected} style={{ width: 147, height: 88 }} />
        </Column>
      </ColumnCenter>

      {/* Okay按钮 */}
      <OkeyBtn
        style={{ background: '#00B595', marginTop: 35 }}
        onClick={() => onConfirm()}
      >
        {
          lang(
            <div style={{ fontSize: '16px', fontFamily: 'Squad-Bold, Squad', fontWeight: 'bold', color: '#FFFFFF', lineHeight: '21px' }}>
              Open a regular cubicle
            </div>,
            <div style={{ fontSize: '16px', fontFamily: 'PingFangSC-SemiBold, PingFang SC', fontWeight: 600, color: '#FFFFFF', lineHeight: '22px' }}>
              使用普通尺寸智能柜
            </div>
          )
        }
      </OkeyBtn>
      <OkeyBtn
        style={{ background: '#F44336', marginTop: 16 }}
        onClick={() => onQuit()}
      >
        {
          lang(
            <div style={{ fontSize: '16px', fontFamily: 'Squad-Bold, Squad', fontWeight: 'bold', color: '#FFFFFF', lineHeight: '21px' }}>
              Quit
            </div>,
            <div style={{ fontSize: '16px', fontFamily: 'PingFangSC-SemiBold, PingFang SC', fontWeight: 600, color: '#FFFFFF', lineHeight: '22px' }}>
              退出
            </div>
          )
        }
      </OkeyBtn>
    </Modal>
  );
};

export interface Props {
  onClose: () => void;
  onConfirm: () => void;
  onQuit: () => void;
}

export default LargeCabNoFreeBoxModal;
